module.exports = __webpack_public_path__ + "../resources/images/balloon-20a6216dba02a69c389fbaaaea3f6f1f.svg";